import React, { Fragment, useEffect, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { saveCharacter } from '../../../actions/character';

const ModModal = ({
    item: {
        items
    },
    selectedItem,
    character: {
        character
    },
    saveCharacter,
    closeStore
}) => {

    const {
        astrobiologyLevel,
        espionageLevel,
        explosivesLevel,
        techLevel,
        inventory
    } = character;

    var [selItem, setSelItem] = useState({'equippedMods': selectedItem.equippedMods, 'modSlots': selectedItem.modSlots});
    var [updatedInv, setUpdatedInv] = useState(inventory);

    const craftables = updatedInv.filter(i => i.type === 'Mod');

    //Set state for filter, selected recipe...

    const addSelectedMod = (mod) => (e) => {

        console.log(mod);

        //Check if all mod slots are being used
        if(selItem.equippedMods.length === selItem.modSlots){
            alert('You have no available mod slots!');
            return;
        }

        //Check if there's already a mod in that slot
        if(selItem.equippedMods.filter(i => i.modLocation === mod.modLocation).length > 0){
            alert('There is already a mod in that slot!');
            return;
        }

        var modArray = [...selItem.equippedMods, mod];

        setSelItem({'equippedMods': modArray, 'modSlots': selItem.modSlots});

        // Remove the added mod from the updated inventory
        var newInv = updatedInv.filter(m => m._id !== mod._id);

        var moddedItem = {
            ...selectedItem,
            "equippedMods": modArray
        }
        
        var selItemInd = newInv.findIndex(i => i._id === selectedItem._id);

        newInv[selItemInd] = moddedItem;

        setUpdatedInv(newInv);

    }

    const removeSelectedMod = (slot) => (e) => {

        var modArray = selItem.equippedMods.filter(i => i.modLocation !== slot);

        var modItem = selItem.equippedMods.find(i => i.modLocation === slot);

        setSelItem({'equippedMods': modArray, 'modSlots': selItem.modSlots});

        // Add mod back to inventory

        var newInv = [...updatedInv, modItem];

        setUpdatedInv(newInv);

    }

    const createModList = () => {

        var itemSuperType = selectedItem.type;

        if(selectedItem.type === "Assault Weapon" || selectedItem.type === "Long Range" || selectedItem.type === "Pistol"){
            itemSuperType = "Gun";
        }

        if(selectedItem.type === "Blade" || selectedItem.type === "Blunt"){
            itemSuperType = "Melee";
        }

        const modList = craftables.filter(i => i.modItem === itemSuperType);

        var displayedMods = modList.map((item, index) => 
            <div  key={index} className="modListItem" onClick={e => addSelectedMod(item)(e)}>
                <div className="modListName">{item.name}</div>
                <div className="modListDescription">{item.description}</div>
            </div>
        );

        return displayedMods;

        
    }

    const gunModSlots = () => {

        return(
        <div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Barrel</div>
                <div className="itemSlotVisual">
                {
                    selItem.equippedMods.filter(x => x.modLocation === "Barrel").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Barrel").name
                }
                </div>
                
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Sight</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Sight").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Sight").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Magazine</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Magazine").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Magazine").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Capacitor</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Capacitor").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Capacitor").name
                }</div>
            </div>
        </div>
        )
    }

    const meleeModSlots = () => {

        return(
        <div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Grip</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Grip").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Grip").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Material</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Material").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Material").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Surface</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Surface").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Surface").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Misc.</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Misc.").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Misc.").name
                }</div>
            </div>
        </div>
        )
    }

    const gloveModSlots = () => {

        return(
            <div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Palm</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Palm").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Palm").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Fingers</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Fingers").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Fingers").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Wrist</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Wrist").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Wrist").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Material</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Material").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Material").name
                }</div>
            </div>
        </div>
        )
    }

    const bodyModSlots = () => {

        return(
            <div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Front</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Front").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Front").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Back</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Back").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Back").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Coating</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Coating").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Coating").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Material</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Material").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Material").name
                }</div>
            </div>
        </div>
        )
    }

    const bootModSlots = () => {

        return(
            <div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Sole</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Sole").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Sole").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Ankle</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Ankle").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Wrist").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Coating</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Coating").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Coating").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Material</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Material").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Material").name
                }</div>
            </div>
        </div>
        )
    }

    const helmModSlots = () => {

        return(
            <div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Visor</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Visor").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Visor").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Accessory</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Accessory").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Accessory").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Coating</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Coating").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Coating").name
                }</div>
            </div>
            <div className="itemSlotContainer">
                <div className="itemSlotLabel">Material</div>
                <div className="itemSlotVisual">{
                    selItem.equippedMods.filter(x => x.modLocation === "Material").length > 0 &&
                    selItem.equippedMods.find(x => x.modLocation === "Material").name
                }</div>
            </div>
        </div>
        )
    }

    // Add shield, drone, pet armor, mech suit, and robot mod slots

    const showSelectedRecipe = () => {

        switch(selectedItem.type){
            case "Assault Weapon":
            case "Long Range":
            case "Pistol":
                return gunModSlots();
            case "Blade":
            case "Blunt":
                return meleeModSlots();
            case "Gloves":
                return gloveModSlots();
            case "Body":
                return bodyModSlots();
            case "Boots":
                return bootModSlots();
            case "Helmet":
                return helmModSlots();
            default:
                return <div className="recipeVisual"></div>
        };
    }

    const closeModModal = () => e => {

        setSelItem({'equippedMods': [], 'modSlots': 0});
        
        closeStore();

    }

    const saveModChanges = () => (e) => {

        saveCharacter({
            ...character,
            'inventory': [...updatedInv]
        });

        closeStore();
    }

    return (
        <Fragment>
            
            <div className="modWrapper">
                <div className="modContainer">
                    <div className="modHeader">
                    
                        <h1>Item Mod Slots</h1>
                        <div className="modSlotCounter">{selItem.equippedMods.length + ' out of ' + selItem.modSlots + ' mods equipped'}</div>
                        <div className='closeCraftingModal' onClick={e => closeModModal()(e)}>X</div>
                    </div>
                    <div className="modItemContainer">
                        {showSelectedRecipe()}
                        <div className="modConfirmButton" onClick={e => saveModChanges()(e)}>Confirm Mods</div>
                    </div>
                </div>
                <div className="availModList">
                    <div id="recipeListContainer">
                        <h2>Available Mods</h2>
                        {createModList()}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

ModModal.propTypes = {
    item: PropTypes.object.isRequired,
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired,
    closeStore: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    item: state.item,
    character: state.character
});

export default connect(mapStateToProps, {saveCharacter})(ModModal);